"use strict";
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sources = void 0;
var Sources;

(function (Sources) {
  // Direct source is when the flags are from passing to the Feature Flag Provider and not from a specific vendor
  Sources["Direct"] = "Direct";
  Sources["Floodgate"] = "Floodgate";
  Sources["LocalStorage"] = "LocalStorage";
})(Sources = exports.Sources || (exports.Sources = {}));